import React from "react"
import styled from 'styled-components';

const TableRow = styled.div`
  flex: 1 0 172px;
  margin-top: 1rem;
`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  // [key: string]: any
}

export class StyledViewTableRow extends React.Component<DivWrapperProps> {
  render() {
    const {children, ...rest} = this.props;
    return <TableRow {...rest}>
      {children}
    </TableRow>;
  }
}

export default StyledViewTableRow;
